import { Note } from '../types/carnetsDeNotes';
import _groupBy from 'lodash-es/groupBy';
import { Eleve } from '@teetsh/app/src/types/eleves';
import { NotationSystem } from '@teetsh/app/src/types/notationSystem';
import { areAllNotesEmpty } from './updateNotesWithNewReferentialItem';
import { findElevesForGroups } from '@teetsh/app/src/containers/CarnetsDeNotes/CarnetDetails/findElevesForGroups';
import { getEvaluationStructure, createNotesForStudent } from './utils/noteCreationUtils';

export interface Result {
  newNotes: Note[];
  areSomeNotesDeleted: boolean;
}

export function updateNotesWithNewGroup(
  notesParam: Note[],
  eleves: Eleve[],
  groups: string[],
  evaluationId: string,
  notationSystem?: NotationSystem,
): Result {
  const notesByEleve = _groupBy(notesParam, n => n.eleveId);
  const evaluationStructure = getEvaluationStructure(notesParam);

  const elevesOfNewGroup = findElevesForGroups(eleves, groups || []);
  const notesToDelete = notesParam.filter(note => {
    const eleve = eleves.find(e => e.id === note.eleveId);
    const eleveBelongToNewGroups = elevesOfNewGroup.find(
      ev => ev.id === eleve?.id,
    );
    return !eleveBelongToNewGroups;
  });

  const notesToAdd = elevesOfNewGroup.reduce((acc, eleve) => {
    const doesEleveHaveNotes = notesByEleve[eleve.id] !== undefined;
    if (doesEleveHaveNotes) {
      return acc;
    }

    const newNotes = createNotesForStudent(eleve.id, evaluationId, evaluationStructure, notationSystem);
    return [...acc, ...newNotes];
  }, [] as Note[]);

  const notesToDeleteIds = notesToDelete.map(note => note.id);

  return {
    newNotes: [
      ...notesParam.filter(note => !notesToDeleteIds.includes(note.id)),
      ...notesToAdd,
    ],
    areSomeNotesDeleted: !areAllNotesEmpty(notesToDelete),
  };
}
